export enum EWidget {
  CHECKBOX = 'checkbox',
  BOOL_SELECT = 'boolSelect',
  CHECKBOXES = 'checkboxes',
  CURRENCY = 'currency',
  PERCENTAGE = 'percentage',
  DATE = 'date',
  FILES = 'files', // file field upload on select
  IN_FORM_FILES = 'inFormFiles',
  FUNC = 'function',
  NUMBER = 'number',
  MULTIPLE = 'multipleSelect',
  RANGE = 'range',
  RADIO = 'radio',
  SINGLE_SELECT = 'singleSelect',
  SINGLE_AUTOCOMPLETE = 'singleAutocomplete',
  SUB_SECTION = 'subSection',
  TEXT = 'text',
  PHONE = 'phoneText',
  HS = 'hscode',
  ESG_TAXONOMY = 'EsgTaxonomy',
  CLIMATE_MIGRATION_ACTIVITY = 'ClimateMitigationActivity', // local options from src/euActivity/activity.ts
  CLIMATE_ADAPTATION_ACTIVITY = 'ClimateAdaptationActivity', // local options from src/euActivity/activity.ts
  DIRECTOR_OR_SHAREHOLDER_INPUT = 'directorOrShareholderInput',
  TEXT_LIST = 'textList',
  UNKNOWN = 'unknown',
  TABULAR_SINGLE = 'tabularSingle',
  TABULAR_MULTIPLE = 'tabularMultiple'
}

